/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import CircularBuffer from './circular-buffer';

// TODO: Špatný název třídy, jelikož tam chybí alespoň klíčové slovo offset.
export default class UnixTimestamp {
  /**
   * Vytvoří instanci.
   */
  constructor() {
    this.offsetTime = 0;
    this.offsetBuffer = [];
    this.circularBuffer = new CircularBuffer(30);
  }

  /**
   * Spočte offset ze zadaných hodnot.
   * @param {number} currentTimeMillis
   * @param {number} fetchEndTimeMillis
   * @returns {number}
   */
  static calculateOffset(currentTimeMillis, fetchEndTimeMillis) {
    return currentTimeMillis - fetchEndTimeMillis;
  }

  /**
   * Nastaví offset.
   * @param {number} offset
   */
  setOffset(offset) {
    this.circularBuffer.add(offset);
    this.offsetTime = median(this.circularBuffer.getAll());
  }

  /**
   * Zjistí offset oproti referenčnímu času.
   * @returns {number} Offset oproti referenčnímu času.
   */
  offset() {
    return this.offsetTime;
  }

  // TODO: WTF, zde totálně chybí zahrnutí offsetu do vráceného výsledku!
  // Volá se to vůbec někde kromě testů?
  /**
   * Získá aktuální čas v ms od UNIX epochy.
   * @returns {number} Čas v ms od UNIX epochy.
   */
  now() {
    return Date.now();
  }
}

/**
 * @param {number[]} arr
 * @returns {number}
 */
export function median(arr) {
  if (arr.length === 0) {
    return NaN;
  }
  // Sort the array
  const sorted = [...arr].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);

  // If even length, return the average of the two middle numbers
  if (sorted.length % 2 === 0) {
    return (sorted[mid - 1] + sorted[mid]) / 2;
  }

  // If odd length, return the middle number
  return sorted[mid];
}
